<template>
  <div class="signature-pad w-full h-full" ref="signature-container">
    <canvas ref="signature" class="w-full h-full"></canvas>
  </div>
</template>
<script>
import SignaturePad from "signature_pad"
import $ from "jquery"
require("signature-pad/jquery.signaturepad.js")

export default {
  emits: ["update"],
  props: {
    value: Object,
    off: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "new" //['new', 'old']
    }
  },
  watch: {
    value: {
      handler(val) {
        if (this.type === "old" && this.off && this.signature) {
          try {
            if (val && val.length > 2) {
              this.signature.regenerate(val)
            }
          } catch (err) {
            console.log("signature problem", val, err)
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    const canvas = this.$refs.signature
    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight

    const that = this
    if (this.type === "new") {
      this.signature = new SignaturePad(canvas, {
        onEnd() {
          that.updateValue()
        }
      })

      if (this.value) {
        this.signature.fromData(this.value)
      }

      if (this.off) {
        this.signature.off()
      }
    } else {
      if (this.off) {
        this.signature = $(this.$refs["signature-container"]).signaturePad({
          displayOnly: true
        })
      } else {
        this.signature = $(this.$refs["signature-container"]).signaturePad({
          displayOnly: false,
          defaultAction: "drawIt",
          drawBezierCurves: true,
          variableStrokeWidth: true,
          lineTop: 110,
          onDrawEnd: function () {
            that.updateValue()
          }
        })
      }

      if (this.value) {
        this.signature.regenerate(this.value)
      }
    }
  },
  methods: {
    updateValue() {
      let value

      if (this.type === "new") {
        value = this.signature.toData()
      } else {
        value = this.signature.getSignatureString()
      }
      this.$emit("update", value)
    },
    clear() {
      if (this.type === "new") {
        this.signature.clear()
      } else {
        this.signature.clearCanvas()
      }
    }
  }
}
</script>
